import { useCallback } from 'react';
import { prop } from 'ramda';
import { useUserSelector, useAppSelector } from 'js/store/hooks';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useGetGameNameTranslations = () => {
    const send = useGenericSend();
    const lang = useUserSelector(prop('lang'));
    const defaultLocale = useAppSelector(prop('defaultLocale'));

    return useCallback(async (
        options: Types.IGetGameNameTranslationsRequest
    ): Promise<Types.IGetGameNameTranslationsResponse> => {
        const { data } = await send<Types.IGetGameNameTranslationsRequest, Types.IGetGameNameTranslationsResponse>({
            ID: 36007,
            responses: [36008, 36009],
            description: 'Get game name translations',
            errorLevel: 1,
            ...options,
            languageCode: options.languageCode || lang || defaultLocale
        });

        return data;
    }, [send, lang, defaultLocale]);
};
